const businessLoanSchemaMarkup = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Mahila Money Business Loan for Women",
    description:
      "Mahila Money offers paperless, collateral-free business loans for women. Avail MSME loans for women with no male co-guarantor required, and unlock your business potential.",
  },
  {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "Mahila Money Business Loan for Women",
    image: "",
    description:
      "Collateral-free, paperless business loans for women entrepreneurs, offering loan amounts up to ₹25 lakhs for both new and established businesses.",
    brand: {
      "@type": "Brand",
      name: "Mahila Money",
    },
    offers: {
      "@type": "AggregateOffer",
      url: "https://mahila.money/mahila-loan",
      priceCurrency: "INR",
      lowPrice: "50000",
      highPrice: "2500000",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Mahila Money",
    url: "https://www.mahila.money",
    logo: "https://blog.mahila.money/wp-content/uploads/2024/07/green-MM-Logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-08095171600",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: ["en", "Hindi"],
      email: "customercare@mahila.money",
    },
    sameAs: [
      "https://www.facebook.com/mahilamoney",
      "https://www.instagram.com/mahila.money",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How can I get a business loan for women?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Simply complete the loan application on the Mahila Money loan app, submit your documents, and our team will get in touch to assist with the process.",
        },
      },
      {
        "@type": "Question",
        name: "Where do I get the money after loan approval?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Once your loan application is approved and processed, the funds will be transferred to your bank account.",
        },
      },
      {
        "@type": "Question",
        name: "How do I check the status of my loan?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "To check the status of your loan, contact customer care via email, WhatsApp, or phone.",
        },
      },
      {
        "@type": "Question",
        name: "What documents are required to apply for a business loan for women?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You need to submit your photograph/selfie, Aadhar card, PAN card, and your bank statement for the past 3-6 months.",
        },
      },
      {
        "@type": "Question",
        name: "I do not have a primary savings or current account with any bank. What should I do?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you do not have your own bank account, Mahila Money urges you to open one through any bank of your choice to process your loan.",
        },
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "How to Apply for a Mahila Money Business Loan",
    description:
      "A step-by-step guide to applying for a Mahila Money business loan.",
    step: [
      {
        "@type": "HowToStep",
        name: "Download the app",
        url: "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
        itemListElement: {
          "@type": "HowToDirection",
          text: "Download the app from Google Play Store.",
        },
      },
      {
        "@type": "HowToStep",
        name: "Fill in the loan application",
        itemListElement: {
          "@type": "HowToDirection",
          text: "Go to 'Loans for your business' and fill in your loan application.",
        },
      },
      {
        "@type": "HowToStep",
        name: "Submit your application",
        itemListElement: {
          "@type": "HowToDirection",
          text: "Submit your application by sharing documents and income proof. Our team will review and get back to you.",
        },
      },
    ],
    supply: {
      "@type": "HowToSupply",
      name: "Mobile Device",
    },
    tool: {
      "@type": "HowToTool",
      name: "Internet Connection",
    },
  },
];

const homeSchemaMarkup = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Mahila Money",
    url: "https://www.mahila.money",
    logo: "https://blog.mahila.money/wp-content/uploads/2024/07/green-MM-Logo.png",
    sameAs: [
      "https://twitter.com/mahilamoney",
      "https://www.facebook.com/mahilamoney",
      "https://www.instagram.com/mahila.money/",
      "https://www.youtube.com/@MahilaMoney",
      "https://www.linkedin.com/company/mahilamoney",
      "https://mahila.money/",
    ],
    potentialAction: {
      "@type": "Action",
      name: "Download the App",
      url: "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
    },
    member: {
      "@type": "Person",
      name: "Women Entrepreneurs",
      description:
        "Join a supportive community for women to discuss business, money, and growth. A safe space to talk about business, money, and more. Connect with women who share your goals.",
    },
  },
  {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "Full Stack Financial Platform for Women",
    image:
      "https://blog.mahila.money/wp-content/uploads/2024/07/green-MM-Logo.png",
    description:
      "Mahila Money connects women with tailored financial products and services for their growth, with a focus on convenience, security, and privacy.",
    brand: {
      "@type": "Brand",
      name: "Mahila Money",
    },
    offers: {
      "@type": "AggregateOffer",
      offerCount: 3,
      offers: [
        {
          "@type": "Offer",
          name: "Business Loans",
          description:
            "Collateral-free business loans designed exclusively for women. No signatures from family required. Apply easily and take control of your finances. Supercharge your business with a Mahila Money loan.",
          priceCurrency: "INR",
          price: "2500000",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "P2P Investments",
          description:
            "Peer-to-peer investment opportunities tailored for women.",
          url: "https://mahila.money/privacy-policy",
        },
        {
          "@type": "Offer",
          name: "Mutual Funds",
          description:
            "Investment options including mutual funds, specifically for women.",
          url: "https://mahila.money/community-guidelines",
        },
      ],
    },
  },
];

const financialProductsSchemaMarkup = [
  {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "Explore Mahila Money's Financial Products: Loans, Investments, Mutual Funds, Expert Business Tips & Live Events",
    image:
      "https://blog.mahila.money/wp-content/uploads/2024/07/green-MM-Logo.png",
    description:
      "Discover Mahila Money range of financial products including loans, investments, mutual funds, and expert business tips. Gain access to live events and expert guidance to fuel your financial journey.",
    url: "https://mahila.money/financial-products",
    brand: {
      "@type": "Brand",
      name: "Explore Mahila Money's Financial Products",
    },
    offers: {
      "@type": "AggregateOffer",
      offerCount: 2,
      offers: [
        {
          "@type": "Offer",
          name: "Mahila Money Loans",
          description:
            "Start or grow your business with loans up to INR 25 lacs, designed exclusively for women.",
          priceCurrency: "INR",
          price: "2500000",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "Get a Loan on Your Merit",
          description:
            "No need for a father’s or partner’s signature—your financial journey is in your hands.",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "Business Loans up to INR 25 Lacs",
          description:
            "Apply for a loan to start or scale your business with no need for collateral or a co-guarantor.",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "Simple Online Process",
          description:
            "Apply, submit documents, and repay—all through our app, anytime, anywhere.",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "No Collateral, No Co-Guarantor",
          description:
            "Enjoy hassle-free, collateral-free loans with no property documents or security required.",
          url: "https://mahila.money/mahila-loan",
        },
        {
          "@type": "Offer",
          name: "Get Expert Tips on Business and Money",
          description:
            "Our products are simple, affordable, and secure. Join live events for expert business guidance.",
          url: "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
        },
        {
          "@type": "Offer",
          name: "Download Mahila Money and #JiyoApneDumPe",
          description:
            "Thousands of women have benefited from the Mahila Money community. Discover helpful financial products tailored to your business needs.",
          url: "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
        },
      ],
    },
  },
];

const aditiSchemaMarkup = [
  {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    name: "Aditi Investment Plan",
    url: "https://mahila.money/aditi-investment-plan",
    description:
      "The Aditi Investment Plan offers investors a safe, high-return option with 9% annual interest. Powered by Rupee Circle and supported by an RBI-licensed NBFC-P2P partnership, it is ideal for individuals seeking a secure short-term investment with easy withdrawal options.",
    brand: {
      "@type": "Brand",
      name: "Aditi",
    },
    provider: {
      "@type": "Organization",
      name: "Rupee Circle",
      description:
        "A trusted RBI-licensed NBFC-P2P partner that provides secure financial products.",
      url: "https://www.rupeecircle.com",
      sameAs: "https://www.rupeecircle.com",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    name: "12-Month Investment Plan",
    description:
      "Earn 9% returns with a 3-month lock-in period. 12-Month Investment Plan. Earn 9% returns with a 3-month lock-in period.",
    interestRate: "9%",
    provider: {
      "@type": "Organization",
      name: "Aditi",
      url: "https://mahila.money/aditi-investment-plan", // Adjust with the correct URL
    },
    category: "Investment",
  },
  {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    name: "Flexible Investment",
    description:
      "Invest at your own pace, anytime, anywhere. Easily continue to build your portfolio.",
    provider: {
      "@type": "Organization",
      name: "Aditi",
      url: "https://mahila.money/aditi-investment-plan",
    },
    category: "Investment",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Key Benefits of Aditi Investment Plan",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Thing",
          name: "Higher returns than traditional savings accounts.",
          description:
            "This investment plan offers better returns compared to typical savings options.",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "Thing",
          name: "3-month investment option with easy withdrawal feature.",
          description:
            "Invest for 3 months with the flexibility of easy withdrawals after the lock-in period.",
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@type": "Thing",
          name: "Fully digital, seamless process for hassle-free investing.",
          description:
            "Experience a fully digital platform that makes investing easy and convenient.",
        },
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "How to Invest in Aditi Investment Plan",
    description: "Follow these four simple steps to start investing.",
    step: [
      {
        "@type": "HowToStep",
        name: "Register",
        text: "Register with your active mobile number and authenticate with an OTP.",
      },
      {
        "@type": "HowToStep",
        name: "Verify Documents",
        text: "Use your PAN and Aadhar details for easy verification without uploading the documents.",
      },
      {
        "@type": "HowToStep",
        name: "Add Bank Account",
        text: "Provide a valid bank account number for smooth transactions, including investments and maturity payouts.",
      },
      {
        "@type": "HowToStep",
        name: "Choose Investment Amount",
        text: "Select your desired investment amount and tenure, make the payment, and start investing.",
      },
    ],
    estimatedCost: {
      "@type": "MonetaryAmount",
      value: "0",
      currency: "INR",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is the Aditi Investment Plan?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Aditi is an investment plan offering a 9% p.a. return powered by Rupee Circle, an RBI-licensed NBFC-P2P partner.",
        },
      },
      {
        "@type": "Question",
        name: "How do I invest in the Aditi Plan?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Simply register, verify your details, add your bank account, choose the investment amount, and start earning.",
        },
      },
      {
        "@type": "Question",
        name: "What documents are required?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Only PAN and Aadhar details are needed for verification. There's no need to upload the documents.",
        },
      },
    ],
  },
];

export {
  businessLoanSchemaMarkup,
  homeSchemaMarkup,
  financialProductsSchemaMarkup,
  aditiSchemaMarkup,
};
